module.exports = __webpack_public_path__ + "img/logo_sr_descripcion.854686d3.png";